var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("the-section", { staticClass: "gallery" }, [
    _c(
      "div",
      { staticClass: "images" },
      _vm._l(_vm.section.medias, function (media) {
        return _c(
          "div",
          {
            key: media._uid,
            ref: "image",
            refInFor: true,
            staticClass: "image",
          },
          [
            _c("img", {
              attrs: { src: _vm.getUrl(media.directus_files_id.id) },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }